export { Ribbon as default } from './Ribbon';
